import Formatter from 'accounting'

export default (number, props) => {
  return Formatter.formatMoney(number, {
    symbol: props.symbol,
    precision: props.precision,
    decimal: props.decimal,
    thousand: props.thousand,
    format: props.format,
  })
}
